import { useState } from 'react';

interface BackButtonProps {
  label: string;
  onClick: () => void;
}

export default function BackButton({ label, onClick }: BackButtonProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="mt-10 pt-6 border-t border-content-border">
      <button
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className={`flex items-center gap-2 w-full justify-center py-3.5 px-6 rounded-[10px] cursor-pointer text-[15px] font-medium transition-all duration-150 border ${
          hovered
            ? 'border-oak-green text-oak-green bg-oak-green/[0.08]'
            : 'border-content-border text-content-secondary bg-white'
        }`}
      >
        {label}
      </button>
    </div>
  );
}
